import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export const ResizablePanelGroup = ({
  className,
  ...props
}: ComponentProps<typeof PanelGroup>) => (
  <PanelGroup
    className={cn('flex h-full w-full data-[panel-group-direction=vertical]:flex-col', className)}
    {...props}
  />
);

export const ResizablePanel = Panel;

export const ResizableHandle = ({
  className,
  withHandle,
  ...props
}: ComponentProps<typeof PanelResizeHandle> & { withHandle?: boolean }) => (
  <PanelResizeHandle
    className={cn(
      'relative flex w-px items-center justify-center bg-neutral-200 transition-colors hover:bg-neutral-300',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-400',
      'data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full',
      'dark:bg-neutral-800 dark:hover:bg-neutral-700',
      className,
    )}
    {...props}
  >
    {withHandle ? (
      <span className="z-10 flex h-6 w-3 items-center justify-center rounded-sm border border-neutral-200 bg-white dark:border-neutral-700 dark:bg-neutral-900">
        <span className="h-3 w-px bg-neutral-300 dark:bg-neutral-600" />
      </span>
    ) : null}
  </PanelResizeHandle>
);
